class Color {
	static sea = '#306ac0';
	static alt_sea = '#c03030';
	static dark_gray_lower = '#888';
	static green = '#27a882';
	static warn = '#ffb700';
	static error = '#ec2e2e';
	static vermillion = '#b7182e';
	static sun = '#ff4a41';
}

export { Color };
